import { Button } from "@/components/ui/button";
import { ArrowRight, Calendar, Phone, Mail } from "lucide-react";

const BottomCTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-nation-blue via-nation-blue-dark to-nation-purple relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('/img/hero-26-1920x480.png')] bg-cover bg-center"></div>
      </div>
      <div className="absolute inset-0 bg-gradient-to-br from-nation-blue/90 via-nation-blue-dark/90 to-nation-purple/90"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Ready to Transform Your Decision-Making?
          </h2>
          <p className="text-xl md:text-2xl mb-8 opacity-90">
            Join the global intelligence revolution. Get real-time insights from
            verified citizen panels across 25+ countries.
          </p>

          {/* Primary CTA */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button
              size="lg"
              className="bg-nation-teal hover:bg-nation-teal-dark text-white px-8 py-4 text-lg h-auto font-semibold shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300"
            >
              <Calendar className="mr-2 h-5 w-5" />
              Request a Demo
            </Button>

            <Button
              size="lg"
              variant="outline"
              className="border-white/30 text-white hover:bg-white/10 px-8 py-4 text-lg h-auto backdrop-blur-sm hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300"
            >
              <Phone className="mr-2 h-5 w-5" />
              Talk to Sales
            </Button>
          </div>

          {/* Feature highlights */}
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300">
              <div className="text-2xl font-bold mb-2">Free Setup</div>
              <div className="text-white/80 text-sm">
                No implementation fees or hidden costs
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300">
              <div className="text-2xl font-bold mb-2">30-Day Trial</div>
              <div className="text-white/80 text-sm">
                Full access to all features
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300">
              <div className="text-2xl font-bold mb-2">Expert Support</div>
              <div className="text-white/80 text-sm">
                Dedicated customer success team
              </div>
            </div>
          </div>

          {/* Alternative contact methods */}
          <div className="border-t border-white/20 pt-8">
            <p className="text-white/80 mb-4">Prefer to reach out directly?</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="/contact?category=partnerships"
                className="flex items-center gap-2 text-nation-teal hover:text-white transition-colors"
              >
                <Mail className="h-4 w-4" />
                Contact our team
              </a>
              <span className="hidden sm:block text-white/40">|</span>
              <a
                href="tel:+1-800-NATION"
                className="flex items-center gap-2 text-nation-teal hover:text-white transition-colors"
              >
                <Phone className="h-4 w-4" />
                +1-800-NATION
              </a>
            </div>
          </div>

          {/* Trust indicators */}
          <div className="mt-12 pt-8 border-t border-white/20">
            <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-white/70">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                <span>SSL Secure</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                <span>GDPR Ready</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                <span>99.9% Uptime SLA</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BottomCTASection;
